import React, { useEffect, useState } from "react";
import Footer from "../component/Footer";
import axios from "axios";
import { useParams } from "react-router-dom";

export default function Blog() {
  const [blog, setBlog] = useState([]);

  const { id } = useParams();

  useEffect(() => {
    if (blog.length === 0) {
      axios
        .get(`${process.env.REACT_APP_SERVER_ROUTE}/blog`)
        .then((res) => {
          setBlog(res.data);
          console.log(blog);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  });
  return (
    <div>
      <div className="bg-white py-24 sm:py-32 ">
        <div className="mx-auto max-w-screen-2xl px-6 lg:px-8">
          {blog.map((post) => (
            <>
              {post.id === id ? (
                <>
                  <div className="max-w-7xl mx-auto">
                    <h2 className=" text-purple-500 my-5 bg-slate-100  max-w-max px-5 font-extrabold py-1 text-2xl  rounded-full">
                      Blog & News
                    </h2>
                    <p className="text-3xl  font-extrabold tracking-tight leading-tight text-gray-800 sm:text-9xl">
                      {post.title}
                    </p>
                  </div>
                  <img
                    src={`/img/blog/${post.id}/${post.imgUrl}`}
                    className="rounded-2xl my-10"
                  />
                </>
              ) : (
                ""
              )}
            </>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
